<div class="title-search-bar">
  <form autocomplete="off">
    <div class="input-group search-group mb-0">
      <span class="pe-3">
        <a><img src="assets/icons/search.svg" class="search-icon" /></a>
      </span>
      <input
        id="search-input"
        type="text"
        class="form-control mb-0"
        autocomplete="off"
        placeholder="Search existing"
        [(ngModel)]="searchQuery"
        [ngModelOptions]="{ standalone: true }"
        (keyup)="search()"
        (blur)="showResults()"
        (focus)="showResults()" />
      <div *ngIf="showSearchResults && hasSearched" id="results-list" class="card">
        <div class="card-body">
          <small>
            <em *ngIf="!items || items.length === 0">No results found</em>
          </small>
          <!-- if theres no client code, we are searching clients -->
          <div *ngIf="items && items.length > 0" class="list-group">
            <button
              class="list-group-item list-group-item-action"
              *ngFor="let item of items.slice(0, maxResultSet)"
              (click)="chosen(item)">
              <div class="row">
                <div class="col-3">{{ item.firstName }}</div>
                <div class="col-3">{{ item.lastName }}</div>
                <div class="col-6">{{ item.userName }}</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
